import React from 'react'
import InnerImageZoom from 'react-inner-image-zoom'
import { map } from 'lodash'

import theme from '~/truck/theme'
import { cloudinary } from '~/utils'
import { transformations } from '~/utils/constants'

import { Container, Thumbnail, ThumbnailsContainer } from './elements'

import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css'

interface GalleryProps {
  alt: string
  photos: string[]
  style?: React.CSSProperties
  className?: string
  selectedPhotoIndex?: number
  setSelectedPhotoIndex?: (index: number) => void
}

function Gallery(props: GalleryProps) {
  const { alt, photos, style, className, selectedPhotoIndex, setSelectedPhotoIndex } = props

  const currentPhoto = photos[selectedPhotoIndex]

  const onThumbnailClick = (index: number) => {
    setSelectedPhotoIndex(index)
  }

  const renderThumbnail = (photo: string, index: number) => {
    return (
      <Thumbnail
        key={`product-image-${index}`}
        src={cloudinary.applyTransformations(photo, transformations.GALLERY_THUMBNAIL)}
        selected={index === selectedPhotoIndex}
        onClick={() => onThumbnailClick(index)}
      />
    )
  }

  return (
    <Container>
      <ThumbnailsContainer style={style} className={className}>
        {map(photos, renderThumbnail)}
      </ThumbnailsContainer>
      <InnerImageZoom
        src={cloudinary.applyTransformations(currentPhoto, transformations.GALLERY_FULL_IMAGE)}
        hideHint
        hideCloseButton
        width={theme.spacing.cozy * 51}
        imgAttributes={{ alt }}
        className={'inner-image-zoom-desktop'}
      />
    </Container>
  )
}

export default Gallery
